import { IS_SEGMENT_ENABLED } from 'gatsby-env-variables'

import { setSourceUrl } from '../envs/handleSourceUrl'

if (IS_SEGMENT_ENABLED) {
  require('./segment')
}

setSourceUrl()
